/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductShowcaseLayout } from './ProductShowcaseLayout';
import {
    ProductShowcaseLayoutFromJSON,
    ProductShowcaseLayoutFromJSONTyped,
    ProductShowcaseLayoutToJSON,
    ProductShowcaseLayoutToJSONTyped,
} from './ProductShowcaseLayout';
import type { ProductShowcaseProduct } from './ProductShowcaseProduct';
import {
    ProductShowcaseProductFromJSON,
    ProductShowcaseProductFromJSONTyped,
    ProductShowcaseProductToJSON,
    ProductShowcaseProductToJSONTyped,
} from './ProductShowcaseProduct';

/**
 * Product showcase ad format configuration
 * @export
 * @interface ProductShowcaseConfig
 */
export interface ProductShowcaseConfig {
    /**
     * 
     * @type {Array<ProductShowcaseProduct>}
     * @memberof ProductShowcaseConfig
     */
    products: Array<ProductShowcaseProduct>;
    /**
     * 
     * @type {ProductShowcaseLayout}
     * @memberof ProductShowcaseConfig
     */
    layout?: ProductShowcaseLayout;
    /**
     * 
     * @type {boolean}
     * @memberof ProductShowcaseConfig
     */
    interactionRequired?: boolean;
}



/**
 * Check if a given object implements the ProductShowcaseConfig interface.
 */
export function instanceOfProductShowcaseConfig(value: object): value is ProductShowcaseConfig {
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function ProductShowcaseConfigFromJSON(json: any): ProductShowcaseConfig {
    return ProductShowcaseConfigFromJSONTyped(json, false);
}

export function ProductShowcaseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductShowcaseConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(ProductShowcaseProductFromJSON)),
        'layout': json['layout'] == null ? undefined : ProductShowcaseLayoutFromJSON(json['layout']),
        'interactionRequired': json['interactionRequired'] == null ? undefined : json['interactionRequired'],
    };
}

export function ProductShowcaseConfigToJSON(json: any): ProductShowcaseConfig {
    return ProductShowcaseConfigToJSONTyped(json, false);
}

export function ProductShowcaseConfigToJSONTyped(value?: ProductShowcaseConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(ProductShowcaseProductToJSON)),
        'layout': ProductShowcaseLayoutToJSON(value['layout']),
        'interactionRequired': value['interactionRequired'],
    };
}

